import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import useRippleEffect from '../hooks/useRippleEffect';
import { auth } from '../firebase-config';
import { signInWithEmailAndPassword } from 'firebase/auth';
// Components
import PageTransition from '../components/PageTransition';
// CSS
import '../assets/css/form-page.css';

export default function Login(props) {
  useRippleEffect();

  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [redirect, setRedirect] = useState(localStorage.getItem('login_redirect_url'));

  useEffect(() => {
    const loginForm = document.querySelector('#login_form');

    loginForm.addEventListener('submit', (e) => {
      e.preventDefault();

      const email = e.target.email.value;
      const password = e.target.password.value;

      signInWithEmailAndPassword(auth, email, password).then((userCredential) => {
        const user = userCredential.user;
        const uid = user.uid;

        if(redirect) {
          const redirectUrl = redirect;
          navigate(redirectUrl);
        }
      }).catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;

        console.log(errorCode, errorMessage);
      });
    })
  }, [])

  return (
    <div className="form_page login_page page_body">
      <PageTransition />
      <div className="container">
        <form className="form_primary" id='login_form'>
          <div className="header">
            {/* <div className="branding select_n"><img src={Branding} alt="CodoHov" /></div> */}
            <div className="form_title">{redirect === null ? 'Login To Your Account' : 'Login To Continue'}</div>
          </div>
          <div className="inputs">
            <div className="input_container">
              <label className="form_label select_n" htmlFor="login-credential">Email</label>
              <input className="form_input" id="login-credential" name='email' type="email" placeholder="Enter your email address" required />
            </div>
            <div className="input_container passowrd">
              <label className="form_label select_n" htmlFor="password">Password <Link to="/forget-password">Forgot Password?</Link></label>
              <input className="form_input" id="password" name='password' type="password" placeholder="******" minLength="6" required />
            </div>
          </div>
          <div className="actions">
            <button className="btn_primary bx_shadow btn_hover ripple-animate ripple-dark bg-1">Login</button>
          </div>
          <div className="sl-link select_n bx_shadow">Don't have an account? <Link to="/signup" className="btn_primary bx_shadow btn_hover ripple-animate bg-2">Signup</Link></div>
        </form>
      </div>
    </div>
  )
}
